    <div class="flex flex-col items-center justify-center py-32 text-center px-6">
      <div class="w-16 h-16 rounded-2xl bg-indigo-500/10 flex items-center justify-center mb-5">
        <i class="pi pi-wrench text-2xl text-indigo-400"></i>
      </div>
      <h2 class="text-lg font-semibold text-slate-200 capitalize">{{ moduleName }}</h2>
      <p class="text-sm text-slate-500 mt-2 max-w-xs">
        This module is not yet available. It will be enabled in a future phase.
      </p>
      <div class="mt-6 inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white/5 text-xs text-slate-500 border border-white/5">
        <span class="w-1.5 h-1.5 rounded-full bg-amber-400 inline-block"></span>
        Phase 0 · Planned
      </div>
    </div>
  
